import React, {useMemo} from 'react'
import Tr from 'translations/Translations';
import SimpleTable from 'components/complex/simpleTable/SimpleTable';
import Loading from 'components/Loading';
import moment from 'moment';
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import DateFormats from "constants/DateFormats";
import IconExternalSignButton from "components/button/IconExternalSignButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PropTypes from 'prop-types';

const useStyle = makeStyles(theme => ({
    root: {},
    cell: {
        padding: theme.spacing(1)
    },
    lpColumn: theme.components.table.lpColumn,
    dateColumn: theme.components.table.dateColumn,
    buttonColumn: theme.components.table.buttonColumn,
    nameColumn: {
        wordBreak: "break-all",
        paddingRight: theme.spacing(2),
    },
    nipColumn: {
        width: 150,
    },
    addressColumn: {
        width: 200,
        whiteSpace: "pre-line"
    },
    emailColumn: {
        width: 170,
        wordBreak: "break-all"
    }
}));

function ContractorTable(
    {
        contractors,
        handleDelete,
        handleExternalSign,
        showJoinDate
    }) {

    const classes = useStyle();
    const showExternalSignColumn = !!handleExternalSign && contractors && contractors.items.findIndex((item, i) => item.externalOfferSign !== null) >= 0;

    const createItem = (item, i) => {
        const {contractor, invitationDate, externalOfferSign, joinMethod, joinDate} = item;

        const arr = [
            `${i + 1}`,
            contractor.name,
            `${contractor.vatin.prefix} ${contractor.vatin.number}`,
            `${contractor.address} \n ${contractor.postCode} ${contractor.city}`,
            contractor.email,
        ];

        if(showJoinDate)
            arr.push(joinMethod === "self" ? moment(joinDate).format(DateFormats.DATETIME_FORMAT) : '')

        arr.push(invitationDate ? moment(invitationDate).format(DateFormats.DATETIME_FORMAT) : '');
        if (handleDelete)
            arr.push(<WorkableIconDeleteButton onClick={() => handleDelete(item)}/>);
        if (showExternalSignColumn)
            arr.push(externalOfferSign !== null ? <IconExternalSignButton enabled={externalOfferSign} onClick={() => handleExternalSign(item)}/> : '');
        return arr;
    }

    const columnClasses = useMemo(() => {
        const arr = [
            classes.lpColumn,
            classes.nameColumn,
            classes.nipColumn,
            classes.addressColumn,
            classes.emailColumn,
        ];
        if(showJoinDate)
            arr.push(classes.dateColumn);

        arr.push(classes.dateColumn);

        if (handleDelete)
            arr.push(classes.buttonColumn);

        if (showExternalSignColumn)
            arr.push(classes.buttonColumn)
        return arr;
    }, [showExternalSignColumn, handleDelete, showJoinDate, classes]);


    const headers = useMemo(() => {
        const arr = [
            Tr('column_lp'),
            Tr('name'),
            Tr('nip_pesel'),
            Tr('adres'),
            Tr('email')
        ]
        if(showJoinDate)
            arr.push(Tr('join_demand_date'));

        arr.push(Tr('forwarding_invitation_date'));

        if (handleDelete)
            arr.push('');

        if (showExternalSignColumn)
            arr.push('');
        return arr;
    }, [showExternalSignColumn, showJoinDate, handleDelete])

    if (!contractors) return <Loading/>
    return (
        <div className={classes.root}>
            <SimpleTable
                headers={headers}
                items={
                    contractors.items.map((item, i) => [
                        ...createItem(item, i)
                    ])
                }
                columnClasses={columnClasses}
                cellClassName={classes.cell}
            />
        </div>
    )
}

ContractorTable.propTypes = {
    contractors: PropTypes.object,
    handleDelete: PropTypes.func,
    handleExternalSign: PropTypes.func,
    showJoinDate: PropTypes.bool
}

export default ContractorTable;
